import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    CoaImportResult, CoaImportRow, OpeningBalanceStatus, OpeningDocumentRow, OpeningDocumentsResult,
    OpeningTrialBalanceResult, OpeningTrialBalanceRow,
} from '../interfaces/openingBalance.interface';

const institution = () => AuthService.getSelectedInstitution() as string;

/** Go-live tooling. Every POST takes dryRun: true previews (nothing written), false commits all-or-nothing. */
export const OpeningBalanceService = {
    status: async (): Promise<OpeningBalanceStatus> =>
        (await axios.get(ENDPOINTS.OPENING_BALANCE.STATUS(institution()))).data,

    importAccounts: async (rows: CoaImportRow[], dryRun: boolean): Promise<CoaImportResult> =>
        (await axios.post(ENDPOINTS.OPENING_BALANCE.ACCOUNTS_IMPORT, { institutionId: institution(), rows, dryRun })).data,

    postTrialBalance: async (
        goLiveDate: string, rows: OpeningTrialBalanceRow[], offsetToEquity: boolean, dryRun: boolean,
    ): Promise<OpeningTrialBalanceResult> =>
        (await axios.post(ENDPOINTS.OPENING_BALANCE.TRIAL_BALANCE,
            { institutionId: institution(), goLiveDate, rows, offsetToEquity, dryRun })).data,

    importCustomers: async (goLiveDate: string, rows: OpeningDocumentRow[], dryRun: boolean): Promise<OpeningDocumentsResult> =>
        (await axios.post(ENDPOINTS.OPENING_BALANCE.CUSTOMERS, { institutionId: institution(), goLiveDate, rows, dryRun })).data,

    importSuppliers: async (goLiveDate: string, rows: OpeningDocumentRow[], dryRun: boolean): Promise<OpeningDocumentsResult> =>
        (await axios.post(ENDPOINTS.OPENING_BALANCE.SUPPLIERS, { institutionId: institution(), goLiveDate, rows, dryRun })).data,
};
